import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

interface IStylesProps {
  rowHeight: number | "auto";
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  table: {
    border: "1px solid #ddd",
    "&.details": {
      borderLeft: "none",
      borderRight: "none"
    }
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: ({ rowHeight }) => rowHeight || 34,
    borderBottom: "1px solid #ddd",
    fontSize: 12,
    color: "#2d2d2d",
    padding: "8px 10px",
    lineHeight: "normal",
    "&.details": {
      fontSize: 14,
      padding: "11px 20px 11px 16px",
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        padding: "11px 12px 11px 12px"
      }
    },
    "&:last-child": {
      borderBottom: "none"
    },
    "&:nth-child(even)": {
      backgroundColor: "#f6f6f6"
    }
  },
  rowName: {
    textTransform: "capitalize",
    maxWidth: "50%"
  },
  rowValue: {
    textAlign: "end",
    position: "relative",
    maxWidth: "50%"
  }
}));
